export default __webpack_public_path__ + "static/media/conteudo_extra_19_31.5a1c4072.jpg";